// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import AddPatient from "../../components/addPatient";

const PatientAdd = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <AddPatient />
    </Main>
  </>
);

export default PatientAdd;
